"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordHashTextInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var models_1 = require("../../../models");
var Checkbox_1 = require("../Checkbox");
var ErrorMessage_1 = require("../ErrorMessage");
var Input_1 = require("../Input");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var ValidationStatus_1 = require("./ValidationStatus");
var DEFAULT_PASSWORD_DISPLAY_LABEL = 'パスワードを表示する';
var INPUT_TYPE = {
    text: 'text',
    password: 'password',
};
var PasswordHashTextInput = function (_a) {
    var propertyId = _a.propertyId, placeholder = _a.placeholder, onChange = _a.onChange, onBlur = _a.onBlur, errorMessages = _a.errorMessages, _b = _a.disabled, disabled = _b === void 0 ? false : _b, className = _a.className, displayError = _a.displayError, value = _a.value, onPasswordDisplayChange = _a.onPasswordDisplayChange, displayPassword = _a.displayPassword, maxLength = _a.maxLength, minLength = _a.minLength, length = _a.length, upperCase = _a.upperCase, lowerCase = _a.lowerCase, number = _a.number, symbol = _a.symbol, _c = _a.passwordDisplayLabel, passwordDisplayLabel = _c === void 0 ? DEFAULT_PASSWORD_DISPLAY_LABEL : _c, _d = _a.inputTypeText, inputTypeText = _d === void 0 ? false : _d;
    var handleChange = function (e) {
        onChange(e.target.value);
    };
    var handleBlur = function (e) {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };
    var isInputTypeText = inputTypeText || displayPassword;
    return ((0, jsx_runtime_1.jsxs)(PropertyInputWrapper_1.PropertyInputWrapper, __assign({ propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.passwordHash, inputFormatType: models_1.PASSWORD_HASH_PROPERTY_INPUT_TYPE.text, errorMessages: errorMessages, className: className, displayError: displayError }, { children: [(0, jsx_runtime_1.jsx)(Input_1.Input, { "data-cy-property-item": true, error: displayError, value: value, type: (isInputTypeText && INPUT_TYPE.text) || INPUT_TYPE.password, placeholder: placeholder, onChange: handleChange, onBlur: handleBlur, disabled: disabled, name: propertyId, id: propertyId, "aria-invalid": displayError, "aria-errormessage": (0, ErrorMessage_1.getFieldErrorMessageId)(propertyId) }), (0, jsx_runtime_1.jsx)(ValidationStatus_1.ValidationStatus, { css: { marginTop: '4px' }, maxLength: maxLength, minLength: minLength, length: length, upperCase: upperCase, lowerCase: lowerCase, number: number, symbol: symbol }), (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, __assign({ css: { marginTop: '4px' }, checked: displayPassword, onChange: onPasswordDisplayChange, disabled: disabled, value: "displayPassword", name: "".concat(propertyId, "-displayPassword") }, { children: passwordDisplayLabel }))] })));
};
exports.PasswordHashTextInput = PasswordHashTextInput;
